/**
 * You must initialize the clients you need below
 */

import { AuthRepo } from "./auth_repo";
// import { QueryRepo } from "./query_repo";
// import { CartRepo } from "./cart_repo";
// import { CoreRepo } from "./core_repo";

export default () => ({
  auth: AuthRepo.getInstance(),
  // query: QueryRepo.getInstance(),
  // core: CoreRepo.getInstance(),
  // cart: CartRepo.getInstance(),
});
